import { HotspotPinComponent, isHotspotPinComponent, PinComponent } from '@lessonup/pins-shared';

// Type definition for hotspot settings
interface HotspotSettings {
  linkedPinComponent?: string;
  showBody?: boolean;
}

// Utility function to check if a hotspot is toggled or selected
export const isToggledOrSelectedHotspot = (selectedPinComponentIds: string[]) => {
  return (pinComponent: PinComponent): pinComponent is HotspotPinComponent => {
    return (
      isHotspotPinComponent(pinComponent) &&
      (pinComponent.settings.showBody || selectedPinComponentIds.includes(pinComponent.id))
    );
  };
};

// Get active hotspots (toggled or selected)
export const getActiveHotspotIds = (pinComponents: PinComponent[], selectedPinComponentIds: string[]) => {
  return pinComponents
    .filter(isToggledOrSelectedHotspot(selectedPinComponentIds))
    .map((pinComponent) => pinComponent.id);
};

// Get components linked to inactive hotspots (these should be hidden)
export const getLinkedToInactiveHotspotIds = (pinComponents: PinComponent[], activeHotspotIds: string[]) => {
  return pinComponents
    .filter((pinComponent) => {
      if (!isHotspotPinComponent(pinComponent)) return false;
      const settings = pinComponent.settings as HotspotSettings;
      return settings.linkedPinComponent && !activeHotspotIds.includes(pinComponent.id);
    })
    .flatMap((hotspot) => {
      const settings = hotspot.settings as HotspotSettings;
      return settings.linkedPinComponent ? [settings.linkedPinComponent] : [];
    });
};

// Check if a component is linked to an inactive hotspot
export const isLinkedToInactiveHotspot = (pinComponentId: string, linkedToInactiveHotspotIds: string[]) => {
  return linkedToInactiveHotspotIds.includes(pinComponentId);
};

// Check if a component is linked to a list of hotspots
export const isLinkedToHotspotList = (pinComponentId: string, hotspotIds: string[], pinComponents: PinComponent[]) => {
  return (
    pinComponents.find((pinComponent) => {
      if (!isHotspotPinComponent(pinComponent)) return false;
      const settings = pinComponent.settings as HotspotSettings;
      return settings.linkedPinComponent === pinComponentId && hotspotIds.includes(pinComponent.id);
    }) || false
  );
};

// Check if a component is an active hotspot
export const isActiveHotspot = (pinComponentId: string, activeHotspotIds: string[]) => {
  return activeHotspotIds.includes(pinComponentId);
};
